import { combineReducers } from 'redux'

import { reducer as login } from './login'
import { reducer as session } from './session'

export const reducer = combineReducers({
  login,
  session
})
